// <head> страницы «Школам»: мета на языке страницы, canonical на себя, hreflang
// между тремя языками (x-default — азербайджанская), FAQPage из тех же вопросов.
import homeCss from "@/components/home/home.css?url";
import chromeCss from "@/components/site/site-chrome.css?url";
import schoolsCss from "./schools.css?url";
import { SCHOOLS_COPY, SCHOOLS_PATH, schoolsFaqJsonLd, withPrices } from "./schools-copy";
import type { SiteLang } from "@/components/site/SiteChrome";
import { jsonLdText } from "@/components/partners/partner-jsonld";
import { OG_LOCALE, socialMeta } from "@/lib/page-meta";

const SITE = "https://yolutap.com";

export function schoolsHead(lang: SiteLang) {
  const c = SCHOOLS_COPY[lang];
  const url = SITE + SCHOOLS_PATH[lang];
  return {
    meta: [
      ...socialMeta({ title: c.meta.title, description: withPrices(c.meta.description) }),
      { property: "og:type", content: "website" },
      { property: "og:url", content: url },
      { property: "og:locale", content: OG_LOCALE[lang] },
    ],
    links: [
      { rel: "canonical", href: url },
      { rel: "alternate", hrefLang: "ru", href: SITE + SCHOOLS_PATH.ru },
      { rel: "alternate", hrefLang: "az", href: SITE + SCHOOLS_PATH.az },
      { rel: "alternate", hrefLang: "en", href: SITE + SCHOOLS_PATH.en },
      { rel: "alternate", hrefLang: "x-default", href: SITE + SCHOOLS_PATH.az },
      { rel: "stylesheet", href: chromeCss },
      { rel: "stylesheet", href: homeCss },
      { rel: "stylesheet", href: schoolsCss },
    ],
    scripts: [{ type: "application/ld+json", children: jsonLdText(schoolsFaqJsonLd(lang)) }],
  };
}
